module.exports = __webpack_public_path__ + "static/godfreys-2da7409588cf8bf66704b1884c18e9bb.jpg";